import { ORGANIZATIONS_API, ORGANIZATION_PHONES_API } from "../../../Utilities/APIs"
import PcBSTCRUD from "../../Partials/Layouts/CRUDs/CRUDLayouts/BSTCRUD/PcBSTCRUD"

function PcOrganizationPhones() {
  return (
    <PcBSTCRUD

        // parentChild props
        parentDBField={'organization'}

        // common props
        api={ORGANIZATION_PHONES_API}
        screenTopicSingular={'Organization Phone'}
        screenTopicPlural={'Organization Phones'}
        
        // crud header props
        showTotalInHeading
        
        // crud props
        allowCreate
        allowUpdate
        allowDelete
        
        // field props

        //text props
        textDBField={'phone'}
        textName={'Phone'}

        //boolean props
        booleanDBField={'isVisible'}
        booleanName={'Is Visible'}
        
        // select props
        selectApi={ORGANIZATIONS_API}
        selectType={'parent-child'}
        selectDBField={'organization'}
        selectName={'Organization'}
    />
  )
}

export default PcOrganizationPhones